module.exports = __webpack_public_path__ + "static/icons/icon-gear-6f1311f99f69df5e096cc1610fef5065.svg";